import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import apiClient from '../../magpiie-client/client';
import type { RootState } from '../store';

export const fetchChannels = createAsyncThunk(
  'channels/fetchChannels',
  async (_, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET('/v2/channels');
    if (error) {
      return rejectWithValue(
        (error as any).message || 'An unknown error occurred'
      );
    }
    return data || [];
  },
  {
    // Prevent duplicate fetches - don't run if already loading
    condition: (_, { getState }) => {
      const { channels } = getState() as RootState;
      if (channels.isChannelLoading) {
        return false;
      }
      return true;
    },
  }
);

/**
 * Fetch channels for a specific organization
 */
export const fetchChannelsForOrg = createAsyncThunk(
  'channels/fetchChannelsForOrg',
  async (orgId: number, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET(
      '/v2/organizations/{orgId}/channels',
      {
        params: { path: { orgId } },
      }
    );
    if (error) {
      return rejectWithValue(
        (error as any).message || 'Failed to fetch channels for organization'
      );
    }
    return { orgId, channels: data || [] };
  },
  {
    // Prevent duplicate fetches for same org
    condition: (orgId, { getState }) => {
      const { channels } = getState() as RootState;
      if (channels.loadingByOrg[orgId] || channels.fetchedByOrg[orgId]) {
        return false;
      }
      return true;
    },
  }
);

export const switchChannel = createAction<number>('channels/switchChannel');
